/// <amd-module name="Feed/Legacy/Protocols/Maven/MavenFileHelper" />
import * as Utils_String from "VSS/Core/Util/String";

import { PackageVersion } from "Feed/Common/Contracts/Feed";

export interface IMavenFile {
    name: string;
    key: string;
}

export function getFiles(packageVersion: PackageVersion): IMavenFile[] {
    const fileNames: IMavenFile[] = [];

    if (packageVersion.files) {
        packageVersion.files.forEach(file => {
            if (!isHashFile(file.name)) {
                fileNames.push({
                    name: file.name,
                    key: file.name
                });
            }
        });
    }
    return fileNames;
}

export function getMetadata(packageVersion: PackageVersion): IMavenFile[] {
    const metadataFiles: IMavenFile[] = [];

    if (isSnapshotVersion(packageVersion)) {
        metadataFiles.push({
            name: "snapshot/maven-metadata.xml",
            key: "snapshotMetadata"
        });
    }

    metadataFiles.push({
        name: "artifact/maven-metadata.xml",
        key: "artifactMetadata"
    });

    metadataFiles.push({
        name: "index.json",
        key: "artifactIndex"
    });

    return metadataFiles;
}

export function isSnapshotVersion(packageVersion: PackageVersion): boolean {
    return packageVersion.version.toLowerCase().indexOf("-snapshot") > -1;
}

function isHashFile(fileName: string): boolean {
    const ignoreCase = true;
    return Utils_String.endsWith(fileName, ".md5", ignoreCase) || Utils_String.endsWith(fileName, ".sha1", ignoreCase);
}
